import { Trade } from '@netswap/sdk'
import React, { Fragment, memo, useContext } from 'react'
import { ChevronRight } from 'react-feather'
import { Flex } from 'rebass'
import { ThemeContext } from 'styled-components'
import { TYPE } from '../../theme'
import { unwrappedToken } from 'utils/wrappedCurrency'
import { useActiveWeb3React } from 'hooks'
import { isEnvChain, NETWORK_CONFIG } from 'utils'

export default memo(function SwapRoute({ trade }: { trade: Trade }) {
  const { chainId } = useActiveWeb3React()
  const theme: any = useContext(ThemeContext as any)
  return (
    <Flex flexWrap="wrap" width="100%" justifyContent="flex-end" alignItems="center">
      {trade.route.path.map((token, i, path) => {
        const isLastItem: boolean = i === path.length - 1
        const currency = unwrappedToken(token)
        return (
          <Fragment key={i}>
            <Flex alignItems="end">
              <TYPE.black fontSize={14} color={theme.text1} ml="0.125rem" mr="0.125rem">
                {chainId && isEnvChain(chainId) && currency.name === 'Ether' && currency.symbol === 'ETH'
                  ? NETWORK_CONFIG[chainId].tokenSymbol
                  : currency.symbol}
              </TYPE.black>
            </Flex>
            {isLastItem ? null : <ChevronRight size={12} color={theme.text2} />}
          </Fragment>
        )
      })}
    </Flex>
  )
})
